<script setup lang="ts">
/**
 * 首启隐私同意弹窗（仅 iOS 工作台包）
 * - 由 App.ku.vue 在 privacyStatus === 'pending' 时渲染，z-index 高于 config-loading-mask
 * - 文案与 Android 原生弹窗（src/androidPrivacy.json）对齐；「不同意」直接退出应用（无二次确认）
 */
import { agreePrivacy, declinePrivacy } from '@/service/privacy';

function openProtocol(type: 1 | 2) {
  uni.navigateTo({ url: `/pages/common/protocol?type=${type}` });
}
</script>

<template>
  <view class="privacy-mask">
    <view class="privacy-card">
      <text class="privacy-title">服务协议和隐私政策</text>
      <view class="privacy-body">
        <view class="privacy-para">
          <text>请你务必审慎阅读、充分理解“服务协议”和“隐私政策”各条款，包括但不限于：为了更好的向你提供服务，我们需要收集你的设备标识、操作日志等信息用于分析、优化应用性能。</text>
        </view>
        <view class="privacy-para">
          <text>你可阅读</text>
          <text class="privacy-link" @tap="openProtocol(2)">《服务协议》</text>
          <text>和</text>
          <text class="privacy-link" @tap="openProtocol(1)">《隐私政策》</text>
          <text>了解详细信息。如果你同意，请点击下面按钮开始接受我们的服务。</text>
        </view>
      </view>
      <view class="privacy-actions">
        <view class="privacy-btn privacy-btn--plain" @tap="declinePrivacy">
          不同意
        </view>
        <view class="privacy-btn privacy-btn--primary" @tap="agreePrivacy">
          同意并接受
        </view>
      </view>
    </view>
  </view>
</template>

<style lang="scss" scoped>
.privacy-mask {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 10000; /* 高于 App.ku.vue 的 config-loading-mask(9999) */
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.6);
}

.privacy-card {
  width: 600rpx;
  padding: 40rpx 32rpx 32rpx;
  border-radius: 16rpx;
  background: $color-white;
  box-sizing: border-box;
}

.privacy-title {
  display: block;
  margin-bottom: 24rpx;
  font-size: 32rpx;
  font-weight: bold;
  text-align: center;
  color: $color-content;
}

.privacy-body {
  margin-bottom: 32rpx;
  font-size: 28rpx;
  line-height: 1.6;
  color: $color-secondary;
}

.privacy-para {
  text-indent: 2em;

  & + & {
    margin-top: 16rpx;
  }
}

.privacy-link {
  color: $color-primary;
}

.privacy-actions {
  display: flex;
  gap: 24rpx;
}

.privacy-btn {
  flex: 1;
  height: 72rpx;
  line-height: 72rpx;
  font-size: 28rpx;
  text-align: center;
  border-radius: 36rpx;

  &--plain {
    color: $color-secondary;
    border: 2rpx solid $color-border;
  }

  &--primary {
    color: $color-white;
    background: $color-primary;
  }
}
</style>
